import type { ContactChannel } from '../components/page'

/**
 * Event names used across the Contact Us fragment.
 * Aligned with the OHF (Order Help Flow) event naming convention.
 */
export const TRACKING_EVENTS = {
  BUTTON_CLICKED: 'Button Clicked',
  EXPERIMENT_CLICKED: 'Experiment Clicked',
  NAVIGATION_CLICKED: 'Navigation Clicked',
  SIGN_IN_FLOW_INITIATED: 'Sign-in Flow Initiated',
  CARE_CASE_SUBMITTED: 'CARE Case Submitted',
  POP_UP_VIEWED: 'Pop-Up Viewed',
  POP_UP_CLICKED: 'Pop-Up Clicked',
} as const

/**
 * Default page-level tracking values for the Contact Us fragment.
 */
export const PAGE_DEFAULTS = {
  CATEGORY: 'Help Center - Contact Us',
  TRACKING_REASON: 'Help',
} as const

/**
 * Step metadata mapping: index → tracking step label.
 *
 * Steps: ContactDetails (0), IssueDescription (1), Confirmation (2)
 */
export const STEP_TRACKING_MAP: Record<number, string> = {
  0: 'Step1',
  1: 'Step2',
  2: 'Confirmation',
}

/**
 * Builds the `pageName` for tracking, following the pattern:
 *   Contact Us:{reason}:{stepLabel}
 *
 * Example: "Contact Us:Help:Step1"
 */
export const buildPageName = (stepIndex: number): string => {
  const stepLabel = STEP_TRACKING_MAP[stepIndex] ?? `Step${stepIndex + 1}`
  return `Contact Us:${PAGE_DEFAULTS.TRACKING_REASON}:${stepLabel}`
}

/**
 * Builds the `destinationPagePath` for navigation events.
 */
export const buildDestinationPath = (stepIndex: number, channel: ContactChannel): string => {
  const stepLabel = STEP_TRACKING_MAP[stepIndex] ?? `Step${stepIndex + 1}`
  return `${PAGE_DEFAULTS.TRACKING_REASON}:${stepLabel}:${channel}`
}
